import { useThree } from "@react-three/fiber";
import { useRef, useMemo } from "react";
import { useSpring } from "react-spring";
import { PointLight, Vector3 } from "three";
import useHashLocation from "../../../use-hash-location";
import { findObjectStartsWithKey } from "../../../utils/FindObjects";

import fragmentShaderReplacement from "../shader/VertexColorHeat_Distance_replacement_frag.glsl";
import fragmentShaderAddition from "../shader/VertexColorHeat_Distance_addition_frag.glsl";

import vertexShaderReplacement from "../shader/VertexColorHeat_Distance_replacement_vert.glsl";
import vertexShaderAddition from "../shader/VertexColorHeat_Distance_addition_vert.glsl";
import { useLayoutEffect } from "react";
import { Color } from "three";
import { useEbbne } from "@solidwhite/ebbnen";

const LightName = "Welding_light_qweqweqw";

const Welding = ({ ...props }) => {
  const { active } = useEbbne();

  const glowing = active;

  const materialRef = useRef();
  const lightRef = useRef();

  const { scene } = useThree();

  useLayoutEffect(() => {
    var l = findObjectStartsWithKey(LightName, scene);
    if (l) {
      lightRef.current = light;
    } else {
      var target = findObjectStartsWithKey("Welding_lighttarget", scene);

      var light = new PointLight(new Color("#ff4800"), 0);

      // light.add(debugSphere);
      light.position.copy(target.position);
      light.name = LightName;
      light.distance = 2.5;
      light.decay = 1;
      target.add(light);
      light.position.copy(new Vector3());

      lightRef.current = light;
    }
  }, [scene]);

  // const heatSource = useMemo(() => {
  //   return findObjectStartsWithKey("Welding_lighttarget", scene);
  // });

  useLayoutEffect(() => {
    var workpiece = findObjectStartsWithKey("ME_Welding_Workpiece", scene);
    var materialClone = workpiece.material.clone();
    // var materialClone = new MeshStandardMaterial();

    var heatSource = findObjectStartsWithKey("Welding_lighttarget", scene);

    var heatSourceWorld = new Vector3();
    heatSource.getWorldPosition(heatSourceWorld);

    materialClone.uniforms = {
      uHeat: {
        value: 0.0,
      },
      uHeatFallof: {
        value: 0.9,
      },
      ...materialClone.uniforms,
    };

    materialClone.onBeforeCompile = (s) => {
      s.uniforms.uHeat = {
        value: 0.0,
      };
      s.uniforms.uHeatFallof = {
        value: 0.2,
      };
      s.uniforms.uHardened = {
        value: 1.0,
      };
      s.uniforms.uHeatSource = {
        value: heatSourceWorld,
      };
      s.uniforms.uHeatDistance = {
        value: 0.3,
      };
      s.vertexShader = `${vertexShaderAddition}${s.vertexShader}`;
      s.vertexShader = s.vertexShader.replace(`#include <fog_vertex>`, vertexShaderReplacement);

      s.fragmentShader = `${fragmentShaderAddition}\n${s.fragmentShader}`;
      s.fragmentShader = s.fragmentShader.replace(`#include <color_fragment>`, ``);
      s.fragmentShader = s.fragmentShader.replace(`#include <dithering_fragment>`, fragmentShaderReplacement);

      materialClone.userData.shader = s;
    };

    materialRef.current = materialClone;
    workpiece.material = materialClone;
  }, [scene]);

  useSpring({
    from: { glow: 0 },
    to: { glow: glowing ? 1 : 0 },
    config: { duration: 1500 },
    delay: glowing ? 500 : 1,
    onRest: () => {
      if (!glowing && lightRef.current) lightRef.current.visible = false;
    },
    onStart: () => {
      if (glowing && lightRef.current) lightRef.current.visible = true;
    },
    onChange: ({ value }) => {
      if (materialRef.current) {
        materialRef.current.userData.shader.uniforms.uHeat.value = value.glow * 4;
      }
      if (lightRef.current) {
        lightRef.current.intensity = value.glow * 1.8;
      }
    },
  });

  return null;
};

export default Welding;
